/* This is the EMIS hand washing components */

<template>
  <v-container>
    <div>
      <span v-html="title"></span>
    </div>
    <div>
      <table
        style="height: 78px; width: 400px"
        border="1px;"
        cellspacing="0px;"
      >
        <tbody>
          <tr>
            <td
              style="
                width: 200px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              បរិយាយ
            </td>
            <td
              style="
                width: 100px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              អត្ថិភាព
            </td>
            <td
              style="
                width: 100px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              ស្ថានភាពទូទៅ
            </td>
          </tr>
          <tr>
            <td class="row-data-left">{{ handWashing[0] }}</td>
            <td class="row-data">
              <v-select
                class="py-0 px-1"
                v-model="data[0].dt[0]"
                :items="yesNo2"
                item-text="text"
                item-value="value"
                outline
                hide-details
                @keypress.native="onSelect($event, 0, 0)"
              >
              </v-select>
            </td>
            <td class="row-data">
              <v-select
                class="py-0 px-1"
                v-model="data[0].dt[1]"
                :items="handWashingCond"
                item-text="text"
                item-value="value"
                outline
                hide-details
                @keypress.native="onSelect2($event, 0, 1)"
              >
              </v-select>
            </td>
          </tr>
          <tr>
            <td class="row-data-left">{{ handWashing[1] }}</td>
            <td class="row-data">
              <v-select
                class="py-0 px-1"
                v-model="data[1].dt[0]"
                :items="handWashingPrio"
                item-text="text"
                item-value="value"
                outline
                hide-details
                @keypress.native="onSelect3($event, 1, 0)"
              >
              </v-select>
            </td>
            <td class="row-data">
              <v-select
                class="py-0 px-1"
                v-model="data[1].dt[1]"
                :items="handWashingCond"
                item-text="text"
                item-value="value"
                outline
                hide-details
                @keypress.native="onSelect2($event, 1, 1)"
              >
              </v-select>
            </td>
          </tr>
          <!-- Row 3 display only for primary and secondary: lastRow=1 -->
          <tr v-if="lastRow == 1">
            <td class="row-data-left">{{ handWashing[2] }}</td>
            <td class="row-data">
              <v-select
                class="py-0 px-1"
                v-model="data[2].dt[0]"
                :items="handWashingPrio2"
                item-text="text"
                item-value="value"
                outline
                hide-details
                @keypress.native="onSelect2($event, 2, 0)"
              >
              </v-select>
            </td>
            <td class="row-data">
              <v-select
                class="py-0 px-1"
                v-model="selectedValues"
                :items="handWashingCond2"
                item-text="text"
                item-value="value"
                multiple
                outline
                hide-details
                @change="onSelectionChange"                
              >
              </v-select>
            </td>
          </tr>
        </tbody>
      </table>      
    </div>
  </v-container>
</template>

<script>
import {
  handWashing,
  handWashingPrio,
  handWashingPrio2,
  handWashingCond,
  handWashingCond2,
  yesNo2,
} from "@/utils/ascf/commonConfig.js";
export default {
  props: ["data", "lastRow", "title"],
  data() {
    return {
      yesNo2: yesNo2,
      handWashing: handWashing,
      handWashingPrio: handWashingPrio,
      handWashingPrio2: handWashingPrio2,
      handWashingCond: handWashingCond,
      handWashingCond2: handWashingCond2,
      selectedValues: []
    };
  },
  mounted() {
    if (this.lastRow && this.lastRow === 1) {
      const raw = this.data[2].dt[1];
      this.selectedValues = raw === 0 ? [] : raw.toString().split('').map(d => parseInt(d));
    }
  },
  methods: {
    onSelectionChange(values) {
      this.data[2].dt[1] = values.length > 0 ? parseInt(values.join('')) : 0;
    },
    onSelect: function (event, r, c) {
      /* 2 options */
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 50) {
        this.data[r].dt[c] = charCode - 48;
        this.$forceUpdate();
      }
    },
    onSelect2: function (event, r, c) {
      /* 3 options */
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 51) {
        this.data[r].dt[c] = charCode - 48;
        this.$forceUpdate();
      }
    },
    onSelect3: function (event, r, c) {
      /* 4 options */
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 52) {
        this.data[r].dt[c] = charCode - 48;
        this.$forceUpdate();
      }
    },
  },
};
</script>
<style scoped>
.row-data {
  width: 100px;
  height: 35px;
  text-align: center;
  vertical-align: middle;
}
.row-data-left {
  width: 200px;
  height: 35px;
  text-align: left;
  vertical-align: middle;
}
.input-group--select >>> .input-group__selections__comma {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 12px;
  padding: 1px 1px 1px 0;
}
.v-input {
  font-size: 12px;
}
</style>